/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  /*
  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

*/
  /* --- START Parkfield - Function to handle product page modal interactions --- */

  if (document.body.classList.contains("template-product")) {
    function setupModal(buttonSelector, modalId) {
      const modal = document.getElementById(modalId);
      if (!modal) return;

      const openBtn = document.querySelector(buttonSelector);
      const closeBtn = modal.querySelector(".close-btn");

      if (openBtn) {
        openBtn.addEventListener("click", () => {
          modal.style.display = "block";
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener("click", () => {
          modal.style.display = "none";
        });
      }

      window.addEventListener("click", (event) => {
        if (event.target === modal) {
          modal.style.display = "none";
        }
      });
    }

    // Setup for Product Options Modal
    setupModal("[data-select-product-options]", "product-options-modal");

    // Setup for Request Quote Modal
    setupModal("[data-request-a-quote]", "request-quote-modal");
  }

  /* --- END Parkfield - Function to handle product page modal interactions --- */

    /* 
    document.querySelectorAll('.subfooter__second_menu_inner').forEach(inner => {
      const title = inner.closest('.subfooter__second_menu_item').querySelector('.subfooter__second_menu_title');
    
      // Add hover event to the inner container
      inner.addEventListener('mouseenter', () => {
        title.classList.add('trigger-underline');  // Add class to trigger underline
      });
    
      // Remove hover effect when leaving the inner container
      inner.addEventListener('mouseleave', () => {
        title.classList.remove('trigger-underline');  // Remove the class to reset the underline
      });
    });
    */



    
})();
